import { useParams } from 'react-router-dom';
import { AssignmentItem } from '@/views/AssignmentsView';
import { ContentWrapper } from '@/widgets/ContentWrapper';
import {
  IAssignmentContextAssignment,
  IAssignmentContextResponse,
  useGetAssignmentContextQuery,
  useGetAssignmentSubmissionQuery,
} from '@/entities/Assignment';
import { getErrorMessage } from '@/shared/lib/utils/getErrorMessage';
import { normalizeAssignmentDetailsItem, parseAssignmentRouteParams } from '../../lib/utils';
import { AssignmentNextLesson } from '../../components/AssignmentNextLesson';
import { AssignmentSubmission } from '../../components/AssignmentSubmission/AssignmentSubmission';

export const AssignmentDetailsView = () => {
  const { groupLessonId, groupExamResubmissionId } = useParams();
  const { params, skip } = parseAssignmentRouteParams(groupLessonId, groupExamResubmissionId);
  const {
    data,
    isLoading: isSubmissionLoading,
    error: submissionError,
  } = useGetAssignmentSubmissionQuery(params, { skip });

  const {
    data: assignmentContext,
    isLoading: isAssignmentContextLoading,
    error: assignmentContextError,
  } = useGetAssignmentContextQuery(params, { skip });

  const isLoading = isSubmissionLoading || isAssignmentContextLoading;
  const error = submissionError || assignmentContextError;
  const nextLessonHref =
    assignmentContext?.nextLesson && data?.student?.enrollmentId
      ? `/enrollments/${data?.student.enrollmentId}/terms/${assignmentContext.term.intakeTermId}/modules/${assignmentContext.module.intakeModuleId}/groups/${assignmentContext.group.number}${assignmentContext.nextLesson.groupLessonId ? `/groupLesson/${assignmentContext.nextLesson.groupLessonId}` : ''}${assignmentContext.nextLesson.groupExamResubmissionId ? `/groupExamResubmission/${assignmentContext.nextLesson.groupExamResubmissionId}` : ''}`
      : '';

  return (
    <ContentWrapper
      isLoading={isLoading}
      isError={!!error}
      error={error}
      errorMessage={getErrorMessage(error) ?? undefined}
      isEmpty={!assignmentContext}
      emptyMessage="Assignment information is not available or not found."
      asSection
      className="flex flex-col gap-y-6"
    >
      {assignmentContext && (
        <>
          {assignmentContext.assignment ? (
            <>
              <AssignmentItem
                item={normalizeAssignmentDetailsItem({
                  submission: data?.submission || null,
                  assignmentContext: {
                    ...assignmentContext,
                    assignment: assignmentContext.assignment as IAssignmentContextAssignment,
                  },
                })}
              />

              <AssignmentSubmission
                student={data?.student || null}
                submission={data?.submission || null}
                assignmentContext={
                  assignmentContext as IAssignmentContextResponse & {
                    assignment: IAssignmentContextAssignment;
                  }
                }
              />
            </>
          ) : (
            <p className="text-muted-foreground">This lesson has no assignment.</p>
          )}

          {assignmentContext?.nextLesson && (
            <AssignmentNextLesson nextLesson={assignmentContext.nextLesson} href={nextLessonHref} />
          )}
        </>
      )}
    </ContentWrapper>
  );
};
